import { createReducer, on, Action } from '@ngrx/store';
import { ApplicationTypeStatusBase } from '@intellio/shared/models';

import * as ApplicationStatusesActions from './application-statuses.actions';

export const APPLICATION_STATUSES_FEATURE_KEY = 'applicationStatuses';

export interface ApplicationStatusesState {
  statuses: Map<string, ApplicationTypeStatusBase[]>;
  loaded: Map<string, boolean>;
  loading: Map<string, boolean>;
  error?: any;
}

export interface ApplicationStatusesPartialState {
  readonly [APPLICATION_STATUSES_FEATURE_KEY]: ApplicationStatusesState;
}

export const initialState: ApplicationStatusesState = {
  statuses: new Map<string, ApplicationTypeStatusBase[]>(),
  loaded: new Map<string, boolean>(),
  loading: new Map<string, boolean>(),
  error: null,
};

const applicationStatusesReducer = createReducer(
  initialState,
  on(ApplicationStatusesActions.getApplicationStatuses, (state, { typeId }) => {
    const loading = new Map(state.loading);
    loading.set(typeId, true);

    return {
      ...state,
      loading,
      error: null,
    };
  }),
  on(
    ApplicationStatusesActions.getApplicationStatusesSuccess,
    (state, { typeId, statuses }) => {
      const loading = new Map(state.loading);
      const loaded = new Map(state.loaded);
      const statusMap = new Map(state.statuses);

      loading.set(typeId, false);
      loaded.set(typeId, true);
      statusMap.set(typeId, statuses);

      return {
        ...state,
        loading,
        loaded,
        statuses: statusMap,
        error: null,
      };
    }
  ),
  on(
    ApplicationStatusesActions.getApplicationStatusesFailure,
    (state, { typeId, error }) => {
      const loading = new Map(state.loading);
      const loaded = new Map(state.loaded);

      loading.set(typeId, false);
      loaded.set(typeId, false);

      return {
        ...state,
        loading,
        loaded,
        error,
      };
    }
  )
);

export function reducer(
  state: ApplicationStatusesState | undefined,
  action: Action
) {
  return applicationStatusesReducer(state, action);
}

